import script from "./LocationRead.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationRead.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__